<template lang="pug">
  v-content(:style="__screen_for_metadata ? 'padding: 0;' : '' ")
    v-flex.text-xs-left(xs12='' v-if="!__screen_for_metadata")
      v-btn(outline='', large='', fab='', color='indigo' @click="openFullscreen()")
        v-icon fullscreen
      v-btn(outline='', large='', fab='', color='indigo' @click="show_search_block = !show_search_block")
        v-icon search
      v-btn(outline='', large='', fab='', color='indigo' @click="getData(0)")
        v-icon refresh

      v-dialog(v-model="dialog" ).rtl
        //v-btn.mb-2(slot="activator" color="primary" dark="") כפתור חדש
        v-card
          //v-card-title
            span.headline יו יו
          v-card-text
            v-container(grid-list-md="").rtl
              //v-layout(wrap="")
              screen(v-if="dialog" :__rowMetadataParams="rowMetadataParams" :__screen_for_metadata="screen_for_metadata")

          v-card-actions
            v-spacer
            v-btn(color="blue darken-1" flat="" @click="dialog = false") סגור

    v-container(fluid ma-0 pa-0 fill-height style="flex-flow: column")#fullscreen-block
      v-layout(
        column 
        v-for="screens_row in screens"
        style="border-bottom: solid 2px #aaa; width: 100%;"
        )
        v-layout(row)
            v-flex(v-for="s in screens_row"
                   :style="{flex : screens_row.length == 1 ? '1 1 auto' : (((desserts[s]||{}).data_screen||{}).style||{}).table_width_multi, 'border-left' : iSmultiTables ? '1px solid #000' : '0' }")
              .rtl(v-if="show_search_block && (((desserts[s]||{}).data_screen||{}).meta||{}).search_fields && (((desserts[s]||{}).data_screen||{}).meta||{}).search_fields.length")
                v-layout(row wrap px-2)
                  v-flex(md6 xs12 px-2 v-for="search_field in (((desserts[s]||{}).data_screen||{}).meta||{}).search_fields")
                    v-text-field(v-model="search_field_models['search_field_' + s + '_' + search_field.column]" :label="search_field.placeholder" append-icon='search' :data-column="search_field.column" :data-screenid="s" v-on:keyup.enter="getData()")

                  v-flex(xs12 pt-2)
                    v-layout(row wrap)
                      v-flex(xs12 pl-1)
                        //templete
                        v-btn(block @click='getData()' color="red lighten-1" dark)  חפש
                      v-flex(xs12 pr-1).-text-xs-left
                        //templete
                        v-btn(block @click='cleanSearchText()' color="blue-grey lighten-2" dark)  נקה

              .headline.text-xs-center.rtl(style="background: #fff;") {{((desserts[s]||{}).data_screen||{}).name}}
                span.caption &nbsp; {{((desserts[s]||{}).data_screen||{}).sub_title}} &nbsp;
                span.caption ({{((desserts[s]||{}).rows || []).length}} שורות)

              // hide-actionsלהחיל גם על הכותרת?
              v-data-table.screen-table(
                :headers='headers[s]'
                :items='(desserts[s]||{}).rows'
                :class="{'multi-tables' : iSmultiTables}"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination[s]"
                style="margin: 0 auto;"
                :style="{width: screens_row.length == 1 ? (((desserts[s]||{}).data_screen||{}).style||{}).table_width_single : 'initial'}"

              )
                template(slot='items', slot-scope='props')
                  td.text-xs-right(
                    v-if="i !== 'meta'"
                    v-for="(cell, i) in props.item"
                    :class="`${i} ${props.item.meta[i].class || ''}`"
                    :style="props.item.meta[i].style"
                    style="height: 0; padding: 0;"
                    @click="!!((desserts[s]||{}).data_screen||{}).screen_for_metadata && !(props.item.meta[i] && props.item.meta[i].click) ? openMetadata(props.item, desserts[s].data_screen.screen_for_metadata) : void(0)")
                    //pre(v-if="props.item.meta[i].click && props.item.meta[i].click.button_type === 'click'") {{ props.item.meta[i].click.column_to_update }}
                    //pre(v-if="props.item.meta[i].click && props.item.meta[i].click.button_type === 'click'") {{ props.item['LineNumber'] }}
                    //pre(v-if="props.item.meta[i].click && props.item.meta[i].click.button_type === 'click'") {{ props.item.meta[i].click.now_value }}
                    | {{ !props.item.meta[i].click ? cell : '' }}
                    v-btn(v-if="props.item.meta[i].click && props.item.meta[i].click.button_type === 'click' && '' + props.item[props.item.meta[i].click.column_to_update] !== '' + props.item.meta[i].click.now_value" color="primary" dark @click="updateColumn(props.item.meta[i].click)") {{ props.item.meta[i].click.button_placeholder }}
                    v-btn(v-if="props.item.meta[i].click && props.item.meta[i].click.button_type === 'click' && props.item.meta[i].click.show_cancel_button && '' + props.item[props.item.meta[i].click.column_to_update] === '' + props.item.meta[i].click.now_value" color="red lighten-1" dark @click="updateColumn(props.item.meta[i].click, 'cancel')") בטל
                    input(v-if="props.item.meta[i].click && props.item.meta[i].click.button_type === 'input'" reverse right :id="i+'-input-'+props.item.meta[i].click.row_id" @keyup="updateColumn(props.item.meta[i].click, i+'-input-'+props.item.meta[i].click.row_id, $event)" :placeholder="props.item.meta[i].click.button_placeholder" class="input-table-update-button")

                template(slot="no-data")
                  v-btn(color="primary") Reset


</template>

<script>
const moment = require('moment-timezone');

export default {
  name: "Screen",
  data: () => ({
    dialog: false,
    show_search_block: false,
    iSmultiTables: false,
    screens: [],
    search: '',
    updatedDate: moment().tz("Asia/Jerusalem"),
    headers: {},
    desserts: {},
    rowsPerPageItems: [3, 5, 10, 20, 50, 100, 1000],
    pagination: {},
    data_names: {},
    columnStyle: {},
    rowMetadataParams: {},
    search_field_models: {},
    screen_for_metadata: 0,
  }),
  props: ['__screen_for_metadata', '__rowMetadataParams'],
  created() {
    this.$socket.on('*', (packet) => {
      let channel = packet.data[0];
      let data = packet.data[1];
      let $uniqid = data.$uniqid;
      if ($uniqid) {
        return this.$socket.res(data);
      }
      this.sockets(channel, data);
    });

    this.$emit('update:loading', false);

    window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem;

    if (this.__screen_for_metadata) {
      this.screens = [[this.__screen_for_metadata]];
    }
    else {
      this.screens = this.$route.params.code.split('-').map(s => s.split(','));
    }

    this.getData();

    setTimeout(() => { // for mot all the pages loaded together in the same time
      setInterval(() => {
        this.getData( 0);
      }, 1000 * 40);
    }, this.getRandomArbitrary(1, 15));
  },

  beforeRouteLeave(to, from, next) {
    this.$socket.off('*');
    this.$emit('update:loading', true);
    next();
  },

  methods: {
    compareCss: function (serverData, screenIdx, rowIdx, cellJdx) {
      let cellCss = '';
      (this.columnStyle[cellJdx] && this.columnStyle[cellJdx].forEach(styleObj => {

        if (+styleObj.screen_id !== +screenIdx) {
          return;
        }
        const column_for_comparison = serverData.screens[screenIdx].rows[rowIdx][styleObj.column_for_comparison];
        switch (styleObj.type_of_condition + "") {
          case '=': {
            if (column_for_comparison === styleObj.condition_value) {
              cellCss += styleObj.css;
            }
            break;
          }
          case '!=': {
            if (column_for_comparison !== styleObj.condition_value) {
              cellCss += styleObj.css;
            }
            break;
          }
          case '<': {
            if (column_for_comparison < styleObj.condition_value) {
              cellCss += styleObj.css;
            }
            break;
        }
          case '>': {
            if (column_for_comparison > styleObj.condition_value) {
              cellCss += styleObj.css;
            }
            break;
          }
          case 'includes': {
            if (column_for_comparison.includes(styleObj.condition_value)) {
              cellCss += styleObj.css;
            }
            break;
            }
          case 'not includes': {
            if (!column_for_comparison.includes(styleObj.condition_value)) {
              cellCss += styleObj.css;
            }
            break;
              }
          case 'תמיד': {
            cellCss += styleObj.css;
            break;
                }
          case 'שעות מעכשיו':
                  {
                    const dadeNs = new Date(column_for_comparison.replace(/ /g, "T") + 'Z').getTime();
                    if (Date.now() - dadeNs > +styleObj.condition_value * 1000 * 60 * 60) {
                      cellCss += styleObj.css;
                    }
                    break;
                  }
        }


        // columnheader
        if (styleObj.apply_to_title) {
          const css = `.theme--light.v-table thead th.columnheader-${styleObj.column_name}-screenIdx-${screenIdx} { ${styleObj.css} }`,
              head = document.head || document.getElementsByTagName('head')[0],
              style = document.createElement('style');

          head.appendChild(style);

          style.type = 'text/css';
          style.appendChild(document.createTextNode(css));
        }
      }));
      return cellCss;
    },

    updateColumn: function (item, input_id = 'false', $event = false) {
      if (!$event || $event.code === 'Enter' || $event.code === 'NumpadEnter') {
        this.loading = true;
        this.$emit('update:loading', true);

        if ($event) {
          const input = document.getElementById(input_id);
          item.now_value = '' + input.value;
          input.value = '';
        }

        if (input_id === 'cancel') {
          item.cancel = true;
        }

        this.$socket.req('xml.screen.update_column', item).then(() => {
          this.getData();
          this.loading = false;
          this.$emit('update:loading', false);
          this.$emit('update:snackbar', {
            text : '✌️ עודכן',
            show : true
          });
        });
      }
    },

    cleanSearchText: function () {
      this.search_field_models = {};
      this.getData();
    },

    openMetadata: function (item, screen_for_metadata) {
      this.rowMetadataParams = item;
      this.screen_for_metadata = screen_for_metadata;

      this.dialog = true;
    },

    getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },

    getData: function (countStatistic = 1) {
      document.title = 'טוען...';
      this.$emit('update:loading', true);

      let searchData = {};
      this.screens.map(s => {
        ((((this.desserts[s]||{}).data_screen||{}).meta||{}).search_fields || []).map(search_field => {
          searchData[s] = searchData[s] || {};
          searchData[s][search_field.column] = this.search_field_models['search_field_' + s + '_' + search_field.column];
        });
      });

      this.$socket.req('xml.screen.get', {countStatistic, rowMetadataParams: this.__rowMetadataParams, screens: this.__screen_for_metadata || this.$route.params.code, searchData: searchData, user: this.$user}).then(serverData => {

        if (serverData.errcode) {
          this.$emit('update:snackbar', {
            text : serverData.errmsg,
            show : true
          });

          this.loading = false;
          this.$emit('update:loading', false);

          return;
        }

        this.data_names = serverData.data_names;
        this.columnStyle = {};

        (serverData.sendi_data_style || []).forEach(row => {
          if (!this.columnStyle[row.column_name]) {
            this.columnStyle[row.column_name] = [];
          }
          this.columnStyle[row.column_name].push(row);
        });

        let sendi_data_button = {};
        (serverData.sendi_data_button || []).forEach(row => {
          if (!sendi_data_button[row.screen_id]) {
            sendi_data_button[row.screen_id] = {};
          }
          sendi_data_button[row.screen_id][row.column_name] = row;
        });

        for (let screenIdx in serverData.screens) {

          const screen_default_rows_to_show = serverData.screens[screenIdx].data_screen.default_rows_number_to_show;

          if (this.pagination[screenIdx]) {
            this.pagination[screenIdx].rowsPerPage = screen_default_rows_to_show;
          } else {
            this.pagination[screenIdx] = {
              rowsPerPage: screen_default_rows_to_show
            }
          }

          this.rowsPerPageItems.indexOf(screen_default_rows_to_show) === -1 ? this.rowsPerPageItems.push(screen_default_rows_to_show) : null;

          this.headers[screenIdx] = [];

          for (let keyIdx in serverData.screens[screenIdx].rows[0]) {
            this.headers[screenIdx].push({
              text: this.data_names[keyIdx] || keyIdx,
              value: keyIdx,
              align: 'right'/*, sortable: false*/,
              // width: data.screens[screenIdx].headers.style[jdx].width
              class: 'columnheader-' + keyIdx + '-screenIdx-' + screenIdx
            });

            // data.screens[screenIdx].rows
          }
        }

        for (let screenIdx in serverData.screens) { // table (AA,PP ...)
          let hadMetaDataRows = false;

          if (serverData.screens[screenIdx].data_screen.screen_for_metadata) {
            hadMetaDataRows = true;
          }

          let alreadyBeep = false;
          for (let rowIdx in serverData.screens[screenIdx].rows) {   // row (0,1 ...)
            const beep_field_name = serverData.screens[screenIdx].data_screen.beep_field_name;
            const beep_type_number = serverData.screens[screenIdx].data_screen.beep_type_number;
            serverData.screens[screenIdx].rows[rowIdx]['meta'] = {};

            for (let cellJdx in serverData.screens[screenIdx].rows[rowIdx]) { // cell (A,B,C, ...)
              serverData.screens[screenIdx].rows[rowIdx]['meta'][cellJdx] = {};
              serverData.screens[screenIdx].rows[rowIdx]['meta'][cellJdx].style = '';

              if (sendi_data_button[screenIdx] && sendi_data_button[screenIdx][cellJdx]) {
                serverData.screens[screenIdx].rows[rowIdx]['meta'][cellJdx].click = {
                  ...sendi_data_button[screenIdx][cellJdx],
                  row_id: serverData.screens[screenIdx].rows[rowIdx].id,
                  user: this.$user,
                }
              }

              if (this.columnStyle['*']) {
                serverData.screens[screenIdx].rows[rowIdx]['meta'][cellJdx].style = this.compareCss(serverData, screenIdx, rowIdx, '*');
              }

              if (!this.__screen_for_metadata && hadMetaDataRows) {
                serverData.screens[screenIdx].rows[rowIdx]['meta'][cellJdx].style += 'cursor: pointer; ';
              }

              serverData.screens[screenIdx].rows[rowIdx]['meta'][cellJdx].style += this.compareCss(serverData, screenIdx, rowIdx, cellJdx);
            }
            if (!alreadyBeep
                && beep_field_name
                && !serverData.screens[screenIdx].rows[rowIdx][beep_field_name]) {
              this.beep(beep_type_number);
              alreadyBeep = true;
              console.log(serverData.screens[screenIdx].rows
                  .filter(it => it.id && !it[beep_field_name])
                  .map(it => it.id))
              this.$socket.req('xml.screen.afterBeep', {
                itemIds: serverData.screens[screenIdx].rows
                    .filter(it => it.id && !it[beep_field_name])
                    .map(it => it.id),
                beep_field_name: beep_field_name
              }).then(data => {
                serverData.screens[screenIdx].rows[rowIdx][beep_field_name] = "🔔 ...beep";
                for (const idx in serverData.screens[screenIdx].rows[rowIdx]['meta']) {
                  serverData.screens[screenIdx].rows[rowIdx]['meta'][idx].class = "blink"
                }
                if (data.success) {
                  this.$emit('update:snackbar', {
                    text : `מסך ${serverData.screens[screenIdx].data_screen.name} סומן כנקרא`,
                    show : true
                  });
                }
              });
            }
          }
        }

        this.desserts = serverData.screens;

        // console.log(serverData.screens)

        let firstScreenId = Object.keys(serverData.screens)[0];
        document.title = ((serverData.screens[firstScreenId] || {}).data_screen || {}).name + '(' +((serverData.screens[firstScreenId] || {}).rows || {}).length + ')';

        // אם לא טוענים מידע אוטומטית בעליה של דף - נא לפתוח את סקשן החיפוש!
        if (!serverData.screens[firstScreenId].data_screen.automatic_information_loading) {
          this.show_search_block = true;
        }

        this.iSmultiTables = Object.keys(this.desserts).length > 1;
        this.loading = false;
        this.$emit('update:loading', false);
        setTimeout(() => {
          document.getElementsByClassName('v-table__overflow')[0].scrollLeft = 20000;
        });
      });
    },

    beep(beep_type_number) {
      // const snd = new Audio("data:audio/wav;base64,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");
      // snd.play();
      const audio = new Audio(require(`@/assets/beeps/${beep_type_number}.mp3`));
      audio.play();
    },

    sockets: function (channel, data) {
      let channels = {
        'screen.data.reload': (data) => {
          // console.log('screen.data.reload BAD!!')
          // this.getData();
        }
      };
      if (!channels[channel]) {
        return console.log('Socket channel not found:', channel);
      }

      return channels[channel](data);
    },

    openFullscreen() {
      var elem = document.querySelector('#fullscreen-block');

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },

    closeFullscreen() {
      var elem = document.documentElement;

      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
    }
  }
}
</script>

<style lang="sass">

//.screen-table.multi-tables
  border-left: 1px solid #000

.screen-table .v-table__overflow
  /*height: 300px;*/
  overflow-y: auto
/*direction: rtl;*/


.screen-table .v-datatable.v-table
  direction: rtl

.screen-table .v-datatable__actions
  direction: ltr


.v-content__wrap
  background: #fff

.input-table-update-button
  border: solid 1px #aaa
  border-radius: 5px

.screen-table
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child)
    padding: 0 5px

.blink
  animation: blink-animation 1s steps(5, start) infinite
  -webkit-animation: blink-animation 1s steps(5, start) infinite
  //color: #42a5f5
  font-weight: bold

@keyframes blink-animation
  to
    visibility: hidden

@-webkit-keyframes blink-animation
  to
    visibility: hidden



</style>
